import { useEffect } from "react";
import { renderStrapiContent } from "../utils/contentfulOptions";
import map from "../images/map.png";
import FullPageLoader from "../components/FullPageLoader";
import StrapiImage from "../components/StrapiImage.js";
import CornerHummingbird from "../images/corner/corner-hummingbird.webp";

const Benvenuti = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - Benvenuti a Auburn Road!";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  const julesScottImage = StrapiImage(info.image);
  const wines = info.wine_pages || [];

  return (
    <>
      <img className="corner-hummingbird" src={CornerHummingbird} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Ciao from Italy</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Benvenuti a Auburn Road!
          </h1>
          <p className="content-hero__intro">
            A warm welcome for guests discovering Auburn Road wines abroad.
          </p>
        </section>

        <section className="content-story">
          {julesScottImage && (
            <div className="content-story__media">
              <img
                className="content-story__photo"
                src={julesScottImage}
                alt="Jules and Scott"
              />
            </div>
          )}
          <div className="content-story__copy">
            {renderStrapiContent(info.content)}
          </div>
        </section>

        <section className="content-story">
          <div className="content-story__media">
            <img className="content-story__photo" src={map} alt="Map" />
          </div>
          <div className="content-media content-media--tall">
            <iframe
              src="https://youtube.com/embed/N--NRgbUOgk?si=YvH6OK_0V0uZ1wdb"
              title="Benvenuti video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </section>

        {wines.length > 0 && (
          <section className="content-section">
            <h2 className="content-section__heading">
              Wines currently available in Italy
            </h2>
            {wines.map((wine, index) => (
              <article key={wine.id || index} className="content-wine-row">
                {wine.wine_art && (
                  <img
                    className="content-wine-row__art"
                    src={StrapiImage(wine.wine_art)}
                    alt={wine.wine_name || ""}
                  />
                )}
                <div>
                  <h3 className="content-wine-row__name">
                    {wine.wine_name || `Wine ${index + 1}`}
                  </h3>
                  <div className="content-story__copy">{wine.description}</div>
                </div>
              </article>
            ))}
          </section>
        )}
      </div>
    </>
  );
};

export default Benvenuti;
